// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getColumnsSchema(param) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Title"
            },
            accessor: (function (txn) {
                return {
                        TAG: /* Text */0,
                        _0: txn.title
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Timestamp"
              },
              accessor: (function (txn) {
                  return {
                          TAG: /* Text */0,
                          _0: Timestamp$Catalyst.toString(txn.ts, "Do MMM YY HH:mm")
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Amount"
                },
                accessor: (function (txn) {
                    return {
                            TAG: /* Text */0,
                            _0: CountryConfig.getSymbol(country) + txn.amount.toString()
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function getView(walletInfo) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: walletInfo,
              children: (function (walletInfo) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: getColumnsSchema(undefined),
                                    rowData: ReasonReactUtils$Catalyst.sliceList(walletInfo.transactions, undefined, 5),
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getColumnsSchema ,
  getView ,
  
}
/* react Not a pure module */
